import { render, staticRenderFns } from "./UploadPicture.vue?vue&type=template&id=1f8a5f56&scoped=true"
import script from "./UploadPicture.vue?vue&type=script&lang=js"
export * from "./UploadPicture.vue?vue&type=script&lang=js"
import style0 from "./UploadPicture.vue?vue&type=style&index=0&id=1f8a5f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8a5f56",
  null
  
)

export default component.exports